import React from 'react'
import {
    TextInput,
    Select,
    SelectItem,
    Checkbox,
} from '@carbon/react';
import { useAppSelector } from '../../../app/hooks';
import { selectWatchfolderEngineProfiles, selectWatchfolderEngines } from '../../../AppSlice';
import { TargetConfig } from './Watchfolder.model';
import { isFingerprintEngine } from '../fingerprinting';

interface IEngineConfigFormProps {
    selectedEngine: string;
    formData: TargetConfig;
    setFormData: (data: TargetConfig) => void;
}

function EngineConfigForm({ selectedEngine, formData, setFormData }: IEngineConfigFormProps) {

    const engines = useAppSelector(selectWatchfolderEngines)
    const engineProfiles = useAppSelector(selectWatchfolderEngineProfiles)
    const fingerprintEngine = isFingerprintEngine(selectedEngine, engines)

    const handleConfigChange = (field: string, value: any) => {
        setFormData({ ...(formData ?? {}), [field]: value });
    };

    if (fingerprintEngine) {
        return null;
    }

    return (
        <div style={{ border: '1px solid #999', borderRadius: 5, padding: 10, marginTop: 15, display: "flex", flexDirection: "column", gap: 10 }}>
            <Select
                id="priority"
                labelText="Priority"
                value={formData.priority ?? ""}
                defaultValue={formData.priority ?? ""}
                onChange={(e) => handleConfigChange('priority', e.target.value)}
            >
                <SelectItem text="Select..." value="" />
                {engines.find(e => e.id === selectedEngine)?.configSchema?.priorityValues?.map(priority => <SelectItem key={priority} text={priority} value={priority} />)}
            </Select>

            {selectedEngine === "CAMBRIA" && <Select
                id="profile"
                labelText="Engine Profile"
                value={formData.profileId ?? ""}
                defaultValue={formData.profileId ?? ""}
                onChange={(e) => handleConfigChange('profileId', e.target.value)}
            >
                <SelectItem text="Select..." value="" />
                {engineProfiles[selectedEngine]?.map(profile => <SelectItem key={profile.uuid} text={profile.label} value={profile.uuid} />)}
            </Select>}

            {selectedEngine === "MEDIAENGINE" && <Select
                id="preset"
                labelText="Engine Preset"
                value={formData.profileId ?? ""}
                defaultValue={formData.profileId ?? ""}
                onChange={(e) => handleConfigChange('profileId', e.target.value)}
            >
                <SelectItem text="Select..." value="" />
                {engineProfiles[selectedEngine]?.map(profile => <SelectItem key={profile.href} text={profile.displayName} value={profile.href} />)}
            </Select>}

            <TextInput
                id="task-submitter"
                labelText="Submitter"
                defaultValue={formData.submitter ?? ""}
                value={formData.submitter ?? ""}
                onChange={(e) => handleConfigChange('submitter', e.target.value)}
            />

            <TextInput
                id="task-output-path"
                labelText="Output Path"
                defaultValue={formData.outputPath ?? ""}
                value={formData.outputPath ?? ""}
                onChange={(e) => handleConfigChange('outputPath', e.target.value)}
                placeholder="/output/folder/"
            />

            <TextInput
                id="task-output-filename"
                labelText="Output Filename"
                defaultValue={formData.outputFilename ?? ""}
                value={formData.outputFilename ?? ""}
                onChange={(e) => handleConfigChange('outputFilename', e.target.value)}
            />

            <Checkbox
                id="use-path-translation"
                labelText="Use Path Translation"
                checked={Boolean(formData.usePathTranslation)}
                onChange={(_e, { checked }) => {
                    setFormData({
                        ...formData,
                        usePathTranslation: checked,
                        pathTranslationLocal: checked ? (formData.pathTranslationLocal ?? '') : '',
                        pathTranslationRemote: checked ? (formData.pathTranslationRemote ?? '') : '',
                    });
                }}
            />

            {formData.usePathTranslation && (
                <>
                    <TextInput
                        id="path-translation-local"
                        labelText="Path Translation: Local"
                        value={formData.pathTranslationLocal ?? ""}
                        onChange={(e) => handleConfigChange('pathTranslationLocal', e.target.value)}
                    />
                    <TextInput
                        id="path-translation-remote"
                        labelText="Path Translation: Remote"
                        value={formData.pathTranslationRemote ?? ""}
                        onChange={(e) => handleConfigChange('pathTranslationRemote', e.target.value)}
                    />
                </>
            )}
        </div>
    )
}

export default EngineConfigForm
